export const ENV = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL as string,
} as const;
